import { render, staticRenderFns } from "./communityActivity.vue?vue&type=template&id=7448ec15&scoped=true"
import script from "./communityActivity.vue?vue&type=script&lang=js"
export * from "./communityActivity.vue?vue&type=script&lang=js"
import style0 from "./communityActivity.vue?vue&type=style&index=0&id=7448ec15&prod&lang=css"
import style1 from "./communityActivity.vue?vue&type=style&index=1&id=7448ec15&prod&scoped=true&lang=css"
import style2 from "./communityActivity.vue?vue&type=style&index=2&id=7448ec15&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7448ec15",
  null
  
)

export default component.exports